// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"3a58a2d4","415":"a31e19ab","515":"564116d4","631":"92bb7d68","773":"6df9c042","790":"59a05b1c","919":"99aa1716"}[chunkId] + ".chunk.js";
};